/**
 * Remembered-email convenience (uat-portal-suite).
 *
 * Story: epic-uat-portal-001-8.
 *
 * A PER-BROWSER convenience ONLY: the last email a tester typed on the login /
 * redeem screen, so the magic-link form can pre-fill it on a return visit. This
 * is NOT sensitive and NOT the session token — the session token is in-memory
 * only (`testerTokenStore.ts`) and never persisted.
 *
 * Every access is wrapped in try/catch: `localStorage` can be absent or throw
 * (private-window, blocked site-data, SSR/test environments), and the portal
 * must render correctly without it.
 */

const REMEMBERED_EMAIL_KEY = 'uat_portal_remembered_email';

/** Read the remembered email, or null if none / storage unavailable. */
export function getRememberedEmail(): string | null {
  try {
    return localStorage.getItem(REMEMBERED_EMAIL_KEY);
  } catch {
    return null;
  }
}

/** Remember the tester's email for next visit. No-op if storage unavailable. */
export function setRememberedEmail(email: string): void {
  try {
    if (email && email.length > 0) {
      localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
    }
  } catch {
    // Storage unavailable (private window / blocked) — silently skip.
  }
}
